import styled from 'styled-components';
import IconWrapper from '../IconWrapper';
import {typographyStyles} from '../../utils/styles';

const StyledAgentAlert = styled.div`
  ${typographyStyles.body.regular};

  align-items: center;
  background-color: ${props => props.theme.colors.additional_purple_light};
  border-radius: ${props => props.theme.border_radius.standard};
  color: ${props => props.theme.colors.additional_purple};
  display: flex;
  padding: 11px 16px;
  margin-bottom: 8px;
`;

const StyledAgentAlertIconWrapper = styled(IconWrapper)`
  margin-top: 4px;
`;

export {
  StyledAgentAlert,
  StyledAgentAlertIconWrapper,
}
